import { MentionButton as MentionButtonCore } from "@/components/ui/editor/core/components/mention-button";
import { useEditorContext } from "../rich-text-editor-provider";

export const MentionButton = () => {
  const { editor } = useEditorContext("Editor");
  if (!editor) return null;
  return <MentionButtonCore editor={editor} />;
};
